import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import { ScrollToTop } from "./components/ScrollToTop";
import Home from "./pages/Home";
import QuiSom from "./pages/QuiSom";
import Serveis from "./pages/Serveis";
import ServeiDetall from "./pages/ServeiDetall";
import Casos from "./pages/Casos";
import Contacte from "./pages/Contacte";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/qui-som" element={<QuiSom />} />
            <Route path="/serveis" element={<Serveis />} />
            <Route path="/serveis/:slug" element={<ServeiDetall />} />
            <Route path="/casos-illustratius" element={<Casos />} />
            <Route path="/contacte" element={<Contacte />} />
            <Route path="/avis-legal" element={<Legal variant="avis" />} />
            <Route path="/politica-privadesa" element={<Legal variant="privadesa" />} />
            <Route path="/politica-cookies" element={<Legal variant="cookies" />} />
            <Route path="/panell" element={<Admin />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0B1320",
            border: "1px solid rgba(197,160,89,0.3)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
